import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { CircularProgress, Typography } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';

import { STONLY_ID } from 'src/lib/stonly';
import Score, { getScoreProps, SCORE_SIZE } from 'src/components/Score';
import { BRIEF_TYPE } from 'src/data/brief';
import { StonlyIcon } from 'src/components/StonlyIcon';
import { SimilarityLabel } from './components/SimilarityLabel';
import { ButtonScoringMethod } from './components/ButtonScoringMethod';
import { useStyles } from './useStyles';

export const Header = ({
  className,
  briefType,
  score,
  basedOnValue,
  loading,
  blocked,
  locked,
  readOnly,
  displayScoringMethod,
  scoringMethodName,
  onScoringMethodClick,
}) => {
  const styles = useStyles();

  const { title } = getScoreProps(score, locked);

  return (
    <div className={cx(styles.root, className, { [styles.locked]: locked })}>
      <div className={styles.titleScoreWrapper}>
        {loading ? (
          <CircularProgress size={40} />
        ) : (
          <Score
            className={styles.score}
            score={score}
            size={SCORE_SIZE.extraLarge}
            locked={locked}
          />
        )}
        <div className={styles.texts}>
          <div className={styles.title}>
            {loading ? (
              <Skeleton
                width={60}
                height={25}
              />
            ) : (
              <Typography className={styles.titleText}>{title}</Typography>
            )}
            <StonlyIcon
              className={styles.stonlyHintIcon}
              stonlyId={STONLY_ID.predictiveScore}
            />
          </div>
          <div className={styles.subtitle}>
            <SimilarityLabel
              basedOnValue={blocked ? 0 : basedOnValue}
              loading={loading}
            />
            {displayScoringMethod && !loading && (
              <>
                <span> using scoring model: </span>
                <ButtonScoringMethod
                  classes={{ name: styles.titleScoringMethod }}
                  className={styles.buttonScoringMethod}
                  briefType={briefType}
                  scoringMethodName={scoringMethodName}
                  onClick={onScoringMethodClick}
                  readOnly={readOnly || locked}
                />
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

Header.propTypes = {
  className: PropTypes.string,
  briefType: PropTypes.oneOf(Object.values(BRIEF_TYPE)),
  score: PropTypes.number,
  basedOnValue: PropTypes.number,
  loading: PropTypes.bool,
  blocked: PropTypes.bool,
  locked: PropTypes.bool,
  readOnly: PropTypes.bool,
  displayScoringMethod: PropTypes.bool,
  scoringMethodName: PropTypes.string,
  onScoringMethodClick: PropTypes.func,
};

Header.defaultProps = {
  className: null,
  briefType: null,
  score: null,
  basedOnValue: null,
  loading: false,
  blocked: false,
  locked: false,
  readOnly: false,
  displayScoringMethod: false,
  scoringMethodName: null,
  onScoringMethodClick: null,
};
